import React from "react";
import NavBar from "../components/NavBar";
import SearchBar from "../components/SearchBar";
import DealsOfTheWeek from "../components/DealsOfTheWeek";
import DiscountedDeals from "../components/DiscountedDeals";
import TopSells from "../components/TopSells";
import Footer from "../components/Footer";
import TopBuilders from "../components/TopBuilders";
import CustomerRating from "../components/CustomerRating";
import Articles from "../components/Articles";

const Home = () => {
    return(
        <div>
            <NavBar/>
            <SearchBar/>
            <DealsOfTheWeek/>
            <DiscountedDeals/>
            <TopSells/>
            <TopBuilders/>
            <CustomerRating/>
            <Articles/>
            <Footer/>
        </div>
    );
};

export default Home;